module.exports = __webpack_public_path__ + "img/OSOJIROBOTICSCORPORATIONCHILESPA.76da0293.png";